import React, { Component } from 'react';
import logger from './logger';

class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '', logsSent: false, incidentId: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true, errorMessage: error.toString() };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to our frontend logger
    logger.error("Uncaught error:", error, errorInfo);

    // You can log the error to an error reporting service here if needed
    console.error("Uncaught error:", error, errorInfo);

    // Send all accumulated logs to the backend
    this.sendLogsToBackend();
  }

  sendLogsToBackend = async () => {
    try {
      // Logger will automatically get token from keycloak or localStorage
      const result = await logger.sendLogsToBackend();

      if (result && result.success) {
        this.setState({
          logsSent: true,
          incidentId: result.incidentId
        });
        logger.clearLogs(); // Clear logs after successful send
      }
    } catch (error) {
      console.error('[Error Boundary] Failed to send logs:', error);
    }
  };

  handleCloseError = () => {
    this.setState({ hasError: false, errorMessage: '', logsSent: false, incidentId: null });
  };

  render() {
    if (this.state.hasError) {
      // Kill the failed component - don't render children
      return (
        <div style={{
          padding: '20px',
          border: '1px solid #ff6b6b',
          borderRadius: '4px',
          backgroundColor: '#ffe0e0',
          color: '#d63031',
          margin: '10px 0'
        }}>
          <h3>Component Error</h3>
          <p>A component has crashed and been removed to prevent further issues.</p>
          {this.state.logsSent && (
            <div style={{ color: '#27ae60', fontWeight: 'bold', marginBottom: '10px' }}>
              <p style={{ margin: 0 }}>✓ Error logs have been sent to the server for analysis.</p>
              {this.state.incidentId && (
                <p style={{ margin: '5px 0 0 0', fontSize: '0.9em', display: 'flex', alignItems: 'center' }}>
                  Incident ID:
                  <span style={{ fontFamily: 'monospace', backgroundColor: '#e8f5e9', padding: '2px 4px', borderRadius: '3px', margin: '0 5px' }}>
                    {this.state.incidentId}
                  </span>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(this.state.incidentId);
                      // Visual feedback could be added here
                    }}
                    title="Copy Incident ID"
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '0 5px',
                      fontSize: '1.2em'
                    }}
                  >
                    📋
                  </button>
                </p>
              )}
            </div>
          )}
          <details>
            <summary>Error Details</summary>
            <pre style={{ fontSize: '12px', overflow: 'auto' }}>
              {this.state.errorMessage}
            </pre>
          </details>
          <button
            onClick={this.handleCloseError}
            style={{
              marginTop: '10px',
              padding: '8px 16px',
              backgroundColor: '#d63031',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Retry Component
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;